(ns splash.ui.lender-portal.config
  (:require
    ["@azure/msal-browser" :as msal]
    [clojure.string :as str]
    [taoensso.timbre :refer-macros [info warn debug error]]))

(def ^:const DD-RUM-CLIENT-TOKEN "pub4e50409571a7e299507a282c1d8ca8a9")
(def ^:const DD-RUM-APPLICATION-ID "ba23c461-b7a4-480c-b12a-6cb168bebf7a")

(def ^boolean debug?
  "shadow-cljs sets this to true when running locally.
   It is used to guard against exposing development elements on deployments."
  js/goog.DEBUG)

(defn msal-logger-callback
  [level, message, containsPii]
  (when (not containsPii)
    (cond
      (= (get msal/LogLevel "Error") level) #(error message)
      (= (get msal/LogLevel "Info") level) #(info message)
      (= (get msal/LogLevel "Verbose") level) #(debug message)
      (= (get msal/LogLevel "Warn") level) #(warn message))))

(def config
  "Client-side configuration map."
  {:prod  {:remote-url         "https://api.splashfinancial.com/lender-portal"
           :optimizely-sdk-key "BgS7p3Kie9NeEb753781S"
           :bugsnag-key        "f3cb07ded46a1f1ead6a0429d7e3d086"
           :msal-tenant-id "72d2e1a8-1773-4229-9676-a92f6ef54bc3"
           :dd-rum-client-token DD-RUM-CLIENT-TOKEN
           :msal  {"auth"  {"clientId" "a838f951-0246-48df-b8fa-d1bb03e9e4ea"
                            "authority" "https://splashlenderprod.ciamlogin.com/",
                            "redirectUri" "/"
                            "postLogoutRedirectUri" "/"}
                   "system"  {"loggerOptions"  {"loggerCallback" msal-logger-callback}}
                   "cache" {"cacheLocation" (.-LocalStorage msal/BrowserCacheLocation)}}}
   :staging {:remote-url         "https://api.staging.splashfinancial.com/lender-portal"
             :optimizely-sdk-key "3zXaCfsv3RqidwpRJx88Q"
             :bugsnag-key        "f3cb07ded46a1f1ead6a0429d7e3d086"
             :msal-tenant-id "ed51dbd9-b720-48a9-b3b2-f68d259b110c"
             :msal  {"auth"  {"clientId" "44d4afd2-ce62-40e4-8766-b3641c75a66e"
                              "authority" "https://splashlenderstage.ciamlogin.com/",
                              "redirectUri" "/"
                              "postLogoutRedirectUri" "/"}
                     "system"  {"loggerOptions"  {"loggerCallback" msal-logger-callback}}
                     "cache" {"cacheLocation" (.-LocalStorage msal/BrowserCacheLocation)}}}
   :stage {:remote-url         "https://api.staging.splashfinancial.com/lender-portal"
           :optimizely-sdk-key "3zXaCfsv3RqidwpRJx88Q"
           :bugsnag-key        "f3cb07ded46a1f1ead6a0429d7e3d086"
           :msal-tenant-id "ed51dbd9-b720-48a9-b3b2-f68d259b110c"
           :dd-rum-client-token DD-RUM-CLIENT-TOKEN
           :msal  {"auth"  {"clientId" "44d4afd2-ce62-40e4-8766-b3641c75a66e"
                            "authority" "https://splashlenderstage.ciamlogin.com/",
                            "redirectUri" "/"
                            "postLogoutRedirectUri" "/"}
                   "system"  {"loggerOptions"  {"loggerCallback" msal-logger-callback}}
                   "cache" {"cacheLocation" (.-LocalStorage msal/BrowserCacheLocation)}}}
   :local {:remote-url         "https://api.staging.splashfinancial.com/lender-portal"
           :local-url          "http://localhost:8080"
           :optimizely-sdk-key "TfTsQkupvHRr2UHZ1FM4B"
           :msal-tenant-id "ed51dbd9-b720-48a9-b3b2-f68d259b110c"
           ;; don't want to record locally always uncomment if needed
           ;;  :dd-rum-client-token DD-RUM-CLIENT-TOKEN
           :msal  {"auth"  {"clientId" "44d4afd2-ce62-40e4-8766-b3641c75a66e"
                            "authority" "https://splashlenderstage.ciamlogin.com/",
                            "redirectUri" "/"
                            "postLogoutRedirectUri" "/"}
                   "system"  {"loggerOptions"  {"loggerCallback" msal-logger-callback}}
                   "cache" {"cacheLocation" (.-LocalStorage msal/BrowserCacheLocation)}}}})

(def config-by-domain
  "Map from domains to config key paths."
  (array-map ; Used to maintain order
    "dev.splashfinancial" :dev
    "stage.splashfinancial" :stage
    "staging.splashfinancial" :staging
    "splashfinancial" :prod
    "localhost" :local))

(defn get-domain-by-location
  "Returns the domain corresponding to the current browser location."
  []
  (let [location (.-href (.-location js/document))]
    (or (first (filter #(str/includes? location %) (keys config-by-domain)))
      "localhost")))

(defn get-config
  "Accepts a single key or a collection of keys for accessing nested maps.
   Returns the config value for the current environment."
  [config-path]
  (let [base-path (if (coll? config-path)
                    config-path
                    [config-path])
        path      (concat [(config-by-domain (get-domain-by-location))] base-path)]
    (get-in config path)))

(defn deployment-env
  []
  (get config-by-domain (get-domain-by-location)))

(defn remote-url
  []
  (get-config [:remote-url]))
